module.exports = __webpack_public_path__ + "static/media/hand-icon.e112bdfc.png";